import api from "@/services/api";

export const state = {
  requests: [],
  request: {},
};

export const mutations = {
  INIT_REQUESTS(state, payload) {
    state.requests = payload;
  },
  INIT_REQUEST(state, payload) {
    state.request = payload;
  },
};

export const actions = {
  getRequests({ commit }, payload) {
    return api.getRequests(payload).then((response) => {
        commit("INIT_REQUESTS", response.data.data);

      if (!payload.retrieveAll) commit("pager/INIT_PAGER", response.data.pagedResult, { root: true });
    });
  },
  getRequest({ commit }, payload) {
    return api.getRequestById(payload).then((response) => {
      commit("INIT_REQUEST", response.data.data);
    });
  },
};

export const getters = {
  getRequests: (state) => state.requests,
  getRequest: (state) => state.request,
};
